import { j as o } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { faWrench as r } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as t } from "@fortawesome/react-fontawesome";
import { Typography as e } from "@mui/joy";
import { memo as i } from "react";
const m = i(() => /* @__PURE__ */ o.jsx(e, { level: "title-md", startDecorator: /* @__PURE__ */ o.jsx(t, { icon: r }), children: "Configuration" }));
m.displayName = "ConfigurationLabel";
export {
  m as default
};
//# sourceMappingURL=ConfigurationLabel.js.map
